module.exports = __webpack_public_path__ + "wasserknapp4.c263c542387a5efb8f8378b41b91dc56.png";